module.exports = __webpack_public_path__ + "static/media/DSC_7906.a2b38905.jpg";